module.exports = __webpack_public_path__ + "img/numberplateSwitzerland.f2e4a648.svg";